<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-做任务-添加
    -->
    <el-dialog
    title="添加做任务"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加做任务</div>
      
      <el-form-item label="选择分类">
          <el-select size="small" v-model="form.category_id" placeholder="所有分类">
            <el-option v-for="(item, index) in category" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

      <el-form-item label="做任务名称" prop="name"><el-input v-model="form.name" placeholder="请输入做任务名称" class="max-w460"></el-input></el-form-item>
    
      


      <el-form-item label="任务logo：" prop="model.image">
      <div class="draggable-list">
        <div class="item">
                <img v-img-url="form.image" alt="file_path"/>
              </div>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

    <el-form-item label="任务介绍">
        <div class="edit_container">
          <el-input type="textarea" v-model="form.intro"></el-input>
        </div>
      </el-form-item>  

      <!-- 0 无需审核  1  需要审核 -->
      <el-form-item label="是否需要审核">
        <el-radio-group v-model="form.is_audit">
          <el-radio :label="0">无需审核</el-radio>
          <el-radio :label="1">需要审核</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="任务类型">
        <el-radio-group v-model="form.code">
          <el-radio label="common">普通任务</el-radio>
          <el-radio label="sport">微信运动任务</el-radio>
        </el-radio-group>
        <div v-if="form.code == 'sport'">微信运动任务无需用户上传，自动获取</div>

      </el-form-item>



      <el-form-item label="任务积分奖励">
        <div class="edit_container">
          <el-input type="number" v-model="form.point"></el-input>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--商品图片组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
   </div>
</el-dialog>
  
</template>

<script>
import DotaskApi from '@/api/dotask.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        image:"",
        category_id:0,
        sort:50,
        intro:"",
        is_audit:0,
        point:0,//奖励积分
        code:"common",//普通任务

      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入做任务名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      category:[]
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getCategory();
  },
  props: ["open_add"],
  methods: {
    getCategory(){
      let self = this;
      let Params = {};
      DotaskApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          if(data.data.vars.values!='[]'){
            if(!data.data.vars.values.category){
              this.category = [];
            }else{
              this.category = data.data.vars.values.category;
            }
          }
          console.log(" this.category", this.category);
          
        })
        .catch(error => {});
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      if(!form.category_id){
        self.$message({
                message:"请选择分类",
                type: 'error'
              });
              return;
      }
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          DotaskApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        let imgs = e[0].file_path;
        this.form.image = imgs
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },


  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/dotask/index/part/add.vue